import { render } from "./agenda.vue?vue&type=template&id=8f0cfe14&scoped=true"
import script from "./agenda.vue?vue&type=script&lang=js"
export * from "./agenda.vue?vue&type=script&lang=js"

import "./agenda.vue?vue&type=style&index=0&id=8f0cfe14&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8f0cfe14"

export default script